import React, { ReactNode } from 'react';
import { extendClassName } from 'utils/common';
import { colors } from 'utils/constants';

interface IBoxWithWhiteFill {
  additionalClassName?: string;
  children: ReactNode;
  centerHorizontal?: boolean;
  centerVertical?: boolean;
  noPadding?: boolean;
}
const BoxWithWhiteFill = ({
  additionalClassName,
  children,
  centerHorizontal = false,
  centerVertical = false,
  noPadding = false,
}: IBoxWithWhiteFill) => {
  return (
    <div
      className={extendClassName('boxWithWhiteFill', [
        centerHorizontal ? 'text-centered' : '',
        centerVertical ? 'flexCentered' : '',
        additionalClassName || '',
      ])}
    >
      {children}

      <style jsx>
        {`
          .boxWithWhiteFill {
            background: white;
            border-radius: 12px;
            ${noPadding ? '' : 'padding: 2.25em 1.75em;'}
          }
        `}
      </style>
    </div>
  );
};

export default BoxWithWhiteFill;
